import { render, staticRenderFns } from "./newopera.vue?vue&type=template&id=adbf3174&scoped=true&"
import script from "./newopera.vue?vue&type=script&lang=js&"
export * from "./newopera.vue?vue&type=script&lang=js&"
import style0 from "./newopera.vue?vue&type=style&index=0&id=adbf3174&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbf3174",
  null
  
)

export default component.exports